import React, {Suspense} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {ChatPage} from './components/chat-page'
import {enableOverflowScrolling} from './actions/chat-root/index.js';
import { addMessageEscaped } from './actions';
import * as appEvents from './utils/appEvents.js';
import * as mode from './utils/mode.js';
import './styles/index.scss';
import './styles/chat.scss';

const ChatHeader = React.lazy(() => import('./components/chat-header'));
const ChatFooter = React.lazy(() => import('./components/chat-footer'));
const ChatBody = React.lazy(() => import('./components/chat-body'));
const ChatFooterButtons = React.lazy(() => import('./components/chat-footer-buttons'));
const ChatModal = React.lazy(() => import('./components/chat-modal'));

export class App extends React.Component {

  componentDidMount () {
    const { addMessageEscaped, enableOverflowScrolling, tabId } = this.props;
    setTimeout(() => enableOverflowScrolling(), 500);
    appEvents.onMounted();
    this.checkWebPluginMode();
    this.checkSinglePageMode();
    this.checkPresetFontSize();

    window.hermes.on('cu:sendMessage', (data) => {
      if (data.tabId === tabId || data.href !== window.location.href) return;
      addMessageEscaped(data.message);
    });
  }

  componentDidUpdate() {
    const { buttons} = this.props;
    const { chatFooterButtons } = this;

    if (chatFooterButtons) {
      this.checkShouldDisplay(chatFooterButtons, buttons.length > 0);
    }
  }

  checkSinglePageMode () {
    const { singlePageMode } = this.props;
    const method = singlePageMode ? 'add' : 'remove';
    document.querySelector('.cu-ui-chat')
      .classList[method]('cu-ui-chat-single-page');
  }

  checkWebPluginMode () {
    const { webPluginMode } = this.props;
    const inspected = mode.inspect(webPluginMode);
    if (inspected.embedded) {
      const method = mode.isEmbeddedStyleEnabled(webPluginMode)
        ? 'add'
        : 'remove';
      document.querySelector('.cu-ui-chat')
        .classList[method]('cu-ui-chat-embedded');
    }
  }

  checkPresetFontSize () {
    const { presetFontSize } = this.props; 
    if (!presetFontSize) {
      return;
    }

    document.querySelector('.cu-ui-chat')
      .classList.add(`cu-ui-preset-font-size-${presetFontSize}`);
  }

  checkShouldDisplay (elem, pred) {
    return pred
      ? elem.style.display = 'block'
      : elem.style.display = 'none';
  }

  renderToolbar = () => {
    const { hideHeader, mode } = this.props;
    return hideHeader
      ? null
      : <ChatHeader mode={mode} />;
  }

  render() {
    const {buttons} = this.props;

    return (
      <Suspense fallback={<div></div>}>
        <ChatPage renderToolbar={this.renderToolbar}>
          <ChatBody />
          <ChatFooterButtons reference={el => this.chatFooterButtons = el} buttons={buttons}/>
          <ChatFooter />
          <ChatModal />
        </ChatPage>
      </Suspense>
    );
  }
}

App.propTypes = {
  title: PropTypes.string,
  mode: PropTypes.bool,
  buttons: PropTypes.array
};

const mapStateToProps = (state, props) => ({
  buttons: state.chatRoot.buttons,
  canSetOverflowScrolling: state.chatRoot.canSetOverflowScrolling,
  hideHeader: state.chatRoot.hideHeader,
  webPluginMode: state.chatRoot.webPluginMode,
  isInputFocused: state.inputField.isInputFocused,
  isFormCellInputFocused: state.chatBody.isFormCellInputFocused,
  tabId: state.chatRoot.tabId,
  singlePageMode: state.chatRoot.singlePageMode,
  presetFontSize: state.chatRoot.presetFontSize
});

const mapDispatchToProps = (dispatch) => {
  return {
    addMessageEscaped: bindActionCreators(addMessageEscaped, dispatch),
    enableOverflowScrolling: bindActionCreators(enableOverflowScrolling, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
